import React, { useRef, useEffect } from 'react';
import '../styles/Slider.css';
import car from '../assets/car.png';
import aircraft from '../assets/aircraft.png';
import driver from '../assets/driver.png';
import party from '../assets/party.png';

const Slider = () => {
    const sliderRef = useRef(null);
    const scrollInterval = useRef(null);

    const images = [
        {
            url: car,
            title: 'Luxury Interior',
            description: 'Premium van comfort'
        },
        {
            url: aircraft,
            title: 'Private Helicopter',
            description: 'Executive air travel'
        },
        {
            url: party,
            title: 'Elite Venues',
            description: 'Luxury event spaces'
        },
        {
            url: driver,
            title: 'Executive Service',
            description: 'Premium car fleet'
        },
        {
            url: party,
            title: 'Elite Venues',
            description: 'Luxury event spaces'
        },
        {
            url: car,
            title: 'Luxury Interior',
            description: 'Premium van comfort'
        },
        {
            url: party,
            title: 'Elite Venues',
            description: 'Luxury event spaces'
        }
    ];

    const startAutoScroll = () => {
        scrollInterval.current = setInterval(() => {
            if (sliderRef.current) {
                const isAtEnd =
                    sliderRef.current.scrollLeft + sliderRef.current.offsetWidth >=
                    sliderRef.current.scrollWidth;

                if (isAtEnd) {
                    sliderRef.current.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    sliderRef.current.scrollBy({ left: 300, behavior: 'smooth' });
                }
            }
        }, 3000); // Scroll every 3 seconds
    };

    const stopAutoScroll = () => {
        if (scrollInterval.current) {
            clearInterval(scrollInterval.current);
        }
    };

    useEffect(() => {
        startAutoScroll();
        return () => stopAutoScroll();
    }, []);

    const scrollLeft = () => {
        stopAutoScroll();
        if (sliderRef.current) {
            sliderRef.current.scrollBy({
                left: -300,
                behavior: 'smooth'
            });
        }
        startAutoScroll();
    };

    const scrollRight = () => {
        stopAutoScroll();
        if (sliderRef.current) {
            sliderRef.current.scrollBy({
                left: 300,
                behavior: 'smooth'
            });
        }
        startAutoScroll();
    };

    return (
        <div className="slider-wrapper">
            <div
                className="slider"
                ref={sliderRef}
                onMouseEnter={stopAutoScroll}
                onMouseLeave={startAutoScroll}
            >
                {images.map((image, index) => (
                    <div key={index} className="slide">
                        <img src={image.url} alt={image.title} />
                        <div className="slide-overlay">
                            <h3>{image.title}</h3>
                            <p>{image.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Slider;
